import type { ResponseAuthorIdentity } from './ResponseAuthorIdentity';

export const authorsMatch = (
	first?: ResponseAuthorIdentity,
	second?: ResponseAuthorIdentity,
): boolean => {
	if (!first || !second || first.isDefault || second.isDefault) {
		return Boolean(first?.isDefault && second?.isDefault);
	}

	return Boolean(
		(first.id && second.id && first.id === second.id) ||
		(first.namedId && second.namedId && first.namedId === second.namedId),
	);
};
